import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ComparisonToggleTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonToggle.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: ComparisonToggleTrackingInfo) => {
    const event: AnalyticsEvent<ComparisonToggleTrackingInfo> = {
        event: EventType.ComparisonToggle,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackOpen = () => {
    track({
        action: "open"
    });
};

export const trackClose = () => {
    track({
        action: "close"
    });
};
